import React, { useEffect, useState } from "react";
import { NavLink, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Btns, ButtonL, Content, Section, TextDiv } from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import { SignClient } from "@walletconnect/sign-client";
import { Web3Modal } from "@web3modal/standalone";
import useDidMountEffect from "../../components/hooks/useDidMountEffect";
import { Modal } from "../../components/modal/Modal";
import { amoActions } from "../../store/slices/amoSlice";
import { getToken } from "../../components/hooks/authFunc";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "../../components/modal/Loading";
const chainToUse = "eip155:8217";

const web3Modal = new Web3Modal({
  projectId: process.env.REACT_APP_PROJECT_ID,
  standaloneChains: [chainToUse],
});

const AddWallet = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = getToken();
  const [coinAddress, setCoinAddress] = useState("");
  const [signClient, setSignClient] = useState();
  const [session, setSession] = useState([]);
  const [account, setAccount] = useState([]);
  const [sigResult, setSigResult] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [openLoading, setOpenLoading] = useState(false);
  const walletAddressAddSuccess = useSelector(
    (state) => state.amo.walletAddressAddSuccess
  );
  const modalMsg = useSelector((state) => state.amo.modalMsg);

  async function createClient() {
    try {
      const signClient = await SignClient.init({
        projectId: process.env.REACT_APP_PROJECT_ID,
      });
      console.log(process.env);
      setSignClient(signClient);
      await subscribeToEvents(signClient);
    } catch (e) {
      console.log(e);
    }
  }
  async function handleConnect() {
    if (!signClient) throw Error("SignClient does not exist");

    try {
      const proposalNamespace = {
        eip155: {
          methods: ["personal_sign"],
          chains: [chainToUse],
          events: [],
        },
      };
      const { uri, approval } = await signClient.connect({
        requiredNamespaces: proposalNamespace,
      });
      console.log("TEST0001");
      // console.log(uri);
      // console.log(approval);
      if (uri) {
        web3Modal.openModal({ uri });
        const sessionNamespace = await approval();
        onSessionConnected(sessionNamespace);
        web3Modal.closeModal();
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function onSessionConnected(session) {
    try {
      console.log(session);
      setSession(session);
      setAccount(session.namespaces.eip155.accounts[0].slice(12));
    } catch (e) {
      console.log(e);
    }
  }

  async function subscribeToEvents(client) {
    if (!client)
      throw Error("Unable to subscribe to events. Client does not exist.");
    try {
      client.on("session_delete", () => {
        console.log("The user has disconnected the session from their wallet.");
        reset();
      });
    } catch (e) {
      console.log(e);
    }
  }
  async function handleSendSigReq() {
    if (!account.length) throw Error("No account found");
    setOpenLoading(true);
    try {
      const result = await signClient.request({
        topic: session.topic,
        chainId: chainToUse,
        request: {
          method: "personal_sign",
          params: [
            "0x46726565646f6d2066726f6d206f707072657373696f6e21",
            account,
          ], // 메시지 "1234" 에 대한 서명 요청
        },
      });

      setSigResult(result);
      //loading stop
      setOpenLoading(false);
      // alert("전자서명에 성공하였습니다");
      const params = {
        address: coinAddress, // 월렛 주소, 필수
        signature: result,
        // message: "0x46726565646f6d2066726f6d206f707072657373696f6e21",
      };

      dispatch(amoActions.fetchWalletAddressAdd({ params, accessToken }));
      // setOpenModal(true);
    } catch (e) {
      alert("전자서명에 실패하였습니다");
      setOpenLoading(false);
      console.log(e);
    }
  }

  const reset = () => {
    setAccount([]);
    setSession([]);
  };

  useEffect(() => {
    if (!signClient) {
      createClient();
    }
  }, [signClient]);

  useDidMountEffect(() => {
    if (account != []) {
      handleSendSigReq();
    }
  }, [account]);

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);
  return (
    <OnePageLayout title="AMO 포인트 교환">
      {openModal && (
        <Modal
          setOpenModal={setOpenModal}
          callbackFunc={
            sigResult && walletAddressAddSuccess
              ? () => {
                  navigate("/amo/init");
                }
              : () => {
                  reset();
                  return;
                }
          }
        >
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
          {/* <p>지갑 주소 등록을 성공하였습니다.</p> */}
        </Modal>
      )}
      {openLoading && <Loading></Loading>}
      <Section>
        <Content>
          <TextDiv>
            <h3>
              AMO 포인트 교환을 위해
              <br />
              <span className="col">부리또 웰렛</span>의 주소를 등록해주세요.
            </h3>
          </TextDiv>

          <AddGuide>
            <AddGuideTextDiv>
              <p>
                <span>AMO(KLAY)</span> 코인이 추가 되어 있지 않다면
                <br />
                아모코인을 추가 하고 주소를 복사해주세요.
              </p>

              <NavLink to={"/amo/wallet/guide"}>주소등록 가이드</NavLink>
            </AddGuideTextDiv>

            <CoinAddressWrap>
              <TextDiv>
                <p>
                  부리또 <span>AMO(KLAY)</span> 코인 주소를 추가해주세요.
                </p>
              </TextDiv>
              <CoinAddress>
                <input
                  type="text"
                  placeholder="코인 주소를 입력해주세요."
                  value={coinAddress}
                  onChange={(e) => {
                    setCoinAddress(e.target.value);
                  }}
                />
              </CoinAddress>
              <Desc>
                포인트 코인 스왑시 AMO 코인을 위 부리또 월렛 주소로 발송됩니다.
              </Desc>
            </CoinAddressWrap>
          </AddGuide>
          <SignGuide>
            <p>
              아래 저장 버튼을 누른 후, 부리또 월렛에서 서명을 진행해주세요.
              <br />
              지갑 서명이 정상적으로 완료 되면 지갑이 등록됩니다.
            </p>
            <NavLink to={"/amo/sign/guide"}>서명 진행가이드</NavLink>
          </SignGuide>
        </Content>
        <Btns>
          <ButtonL onClick={handleConnect} disabled={!coinAddress}>
            저장
          </ButtonL>
        </Btns>
      </Section>
    </OnePageLayout>
  );
};

export default AddWallet;
const AddGuide = styled.div`
  background-color: #fff;
  border-top: 1px dashed #919191;
  border-bottom: 1px dashed #919191;
  margin-top: 2rem;
  padding: 3rem 1.5rem;
  text-align: center;
  a {
    display: inline-block;
    margin-top: 1.5rem;
    color: ${({ theme }) => theme.color.purple_second};
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 2rem; /* 142.857% */
    text-decoration-line: underline;
  }
`;
const AddGuideTextDiv = styled(TextDiv)`
  line-height: 2rem;
`;
const CoinAddressWrap = styled.div`
  margin-top: 6rem;
  text-align: center;
  p {
    line-height: 1.4rem; /* 100% */
  }
`;
const CoinAddress = styled.div`
  margin-top: 1rem;
  height: 4.6rem;
  background-color: ${({ theme }) => theme.color.purple_bg_light};
  border-radius: 2.3rem;

  display: flex;
  align-items: center;
  justify-content: center;

  input {
    width: 90%;
    text-align: center;
    background-color: transparent;
    font-size: 1.2rem;
    line-height: 2rem; /* 166.667% */
    font-family: NanumSquareB;
    &:focus {
      outline: none;
    }
    &::placeholder {
      color: ${({ theme }) => theme.color.input_text_gray};
    }
  }
`;

const Desc = styled.p`
  width: calc(100% - 4.4rem);
  text-align: left;
  margin-top: 1rem;
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: 500;
  margin: 1rem auto 0 auto;
`;
const SignGuide = styled.div`
  margin-top: 2rem;
  text-align: center;
  p {
    text-align: left;
    color: #251562;
    font-family: NanumSquareR;
    font-size: 1.2rem;
    line-height: 16px; /* 133.333% */
    letter-spacing: -0.6px;
  }
  a {
    display: inline-block;
    margin-top: 1.5rem;
    color: ${({ theme }) => theme.color.purple_second};
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 2rem; /* 142.857% */
    text-decoration-line: underline;
  }
`;
